module.exports = __webpack_public_path__ + "img/maison8.94d6ebaf.jpg";